import _ from 'lodash';

const minValue = min => value =>
  value && value.length < min
    ? `Password must be at least ${min} characters`
    : undefined;

export const required = value => {
  return (_.isArray(value) && !_.isEmpty(value)) ||
    (_.isObject(value) && _.has(value, 'value') && !_.isNil(value.value)) ||
    (!_.isArray(value) && !_.isObject(value) && value)
    ? undefined
    : 'Required';
};

const minValue8 = minValue(8);

const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;

export const maxLength50 = maxLength(50);
export const maxLength250 = maxLength(250);
export const maxLength255 = maxLength(255);
export const maxLength1024 = maxLength(1024);

const maxLengthInArray = max => array => {
  const errors = {};
  if (!_.isArray(array)) return;

  array.map((element, index) => {
    if (element.length > max)
      errors[index] = `Must be ${max} characters or less`;
    return element;
  });

  if (!_.isEmpty(errors)) return errors;
};

const maxArrayLength = max => value =>
  value && value.length > max
    ? `A maximum of ${max} elements is allowed`
    : undefined;

export const maxArrayLength10 = maxArrayLength(10);

export const maxLengthInArray255 = maxLengthInArray(255);

export const strongPassword = [minValue8, required];
